import { StyleProp, ViewStyle } from "react-native";
import { FC, memo } from "react";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import { PressableScale } from "pressto";
import { Icon } from "../Icon";

type BackRoundedButtonProps = {
  onPress: () => void;
  style?: StyleProp<ViewStyle>;
};

export const BackRoundedButton: FC<BackRoundedButtonProps> = memo(({ onPress, style }) => {
  const { theme } = useUnistyles();
  return (
    <PressableScale onPress={onPress} hitSlop={16} style={[styles.backButton, style]}>
      <Icon name="chevronLeft" color={theme.colors.white.default} />
    </PressableScale>
  );
});

const styles = StyleSheet.create((theme) => ({
  backButton: {
    height: 40,
    width: 40,
    backgroundColor: "transparent",
    borderRadius: theme.spacing.md,
    borderCurve: "continuous",
    borderWidth: 1,
    borderColor: theme.colors.surface1.foregroundSecondary,
    justifyContent: "center",
    alignItems: "center",
  },
}));
